/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { useSelector, connect } from "react-redux";
import { PropTypes } from "prop-types";
import get from "lodash/get";

import { WithLazy } from "@quintype/components";

import { replaceScriptNodes } from "../../utils";
import { ErrorBoundary } from "../error-boundary";
import "../collection-templates/custom-widget-row/widget.m.css";

class CustomWidgetComponent extends React.Component {
  constructor(props) {
    super(props);
    this.widgetSlot = React.createRef();
  }

  componentDidMount = () => {
    const currentNode = this.widgetSlot.current;
    currentNode && replaceScriptNodes(currentNode);
  };

  render() {
    if (!this.props.widgetValue || typeof window === "undefined") return null;
    return (
      <ErrorBoundary>
        <div
          styleName={`customWidgetWrapper widget ${this.props.shouldRenderWidgetWrapperBackground ? 'customWidgetWrapperBackground' : ''}`}
          ref={this.widgetSlot}
          dangerouslySetInnerHTML={{ __html: this.props.widgetValue }}
          data-test-id="widget"
        />
      </ErrorBoundary>
    );
  }
}

CustomWidgetComponent.propTypes = {
  widgetValue: PropTypes.string,
  shouldRenderWidgetWrapperBackground: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    shouldRenderWidgetWrapperBackground: get(state, ['qt', 'config', 'pagebuilder-config', 'general', 'others', 'enableAdPlaceholderBackground'], false),
  };
}

export const CustomWidget = connect(mapStateToProps)(CustomWidgetComponent);
export const CustomWidgetUnconnected = CustomWidgetComponent;

export const WidgetComponent = (props) => {
  const removeThirdPartyScripts = useSelector((state) => get(state, ['qt', 'removeThirdPartyScripts'], false));
  if (removeThirdPartyScripts) return null;
  const { lazyLoadWidget = true } = useSelector((state) =>
    get(state, ["qt", "config", "pagebuilder-config", "general", "widget"], {})
  );
  if (lazyLoadWidget) {
    return (
      <WithLazy margin="0px">{() => <CustomWidget {...props} />}</WithLazy>
    );
  }
  return <CustomWidget {...props} />;
};

WidgetComponent.propTypes = {
  widgetValue: PropTypes.string,
};
